
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5.852C5.146.852 0 5.998 0 12.352c0 6.353 5.146 11.5 11.5 11.5S23 18.705 23 12.352c0-6.354-5.146-11.5-11.5-11.5zm0 3.45a3.45 3.45 0 110 6.9 3.45 3.45 0 110-6.9zm0 16.33c-2.88 0-5.41-1.472-6.9-3.703.029-2.283 4.606-3.542 6.9-3.542 2.294 0 6.866 1.259 6.9 3.542-1.49 2.23-4.02 3.703-6.9 3.703z","fill":"#007185"}})])
          )
        }
      }
    